const updateItems = [
  {
    id: 'update-1',
    date: '2026-07-30',
    title: '暑期档大片专区正式上线',
    desc: '汇聚今夏最热门院线大片与经典暑期档电影，打造专属观影专题页面。新增多部高分作品，涵盖动作、喜剧、科幻等热门类型，满足不同观众的暑期观影需求。',
    tag: '功能更新',
  },
  {
    id: 'update-2',
    date: '2026-07-25',
    title: '播放器全新升级 · 支持4K画质',
    desc: '底层播放引擎全面重构，新增4K超高清画质选项。同时优化了多线路切换逻辑，在网络波动时自动无缝切换最佳节点，大幅减少缓冲等待时间。',
    tag: '技术升级',
  },
  {
    id: 'update-3',
    date: '2026-07-18',
    title: '手机版夜间模式上线',
    desc: '手机版新增深色主题夜间模式，降低屏幕亮度对眼睛的刺激。根据系统时间自动切换，也可手动设置偏好，让深夜观影更加舒适护眼。',
    tag: '体验优化',
  },
  {
    id: 'update-4',
    date: '2026-07-12',
    title: '海外剧场频道扩容',
    desc: '大幅扩充海外影视内容库，新增200余部高分英美剧、日韩剧、欧洲文艺片等。全部配备中文字幕，原声与配音双版本可选，满足不同语言偏好的观众。',
    tag: '内容更新',
  },
  {
    id: 'update-5',
    date: '2026-07-05',
    title: '蓝光画质专区全面开放',
    desc: '蓝光专区取消画质限制，全站所有影片均可选择蓝光1080P画质。同时优化了码率自适应算法，在保证画质的前提下进一步降低带宽消耗。',
    tag: '画质升级',
  },
  {
    id: 'update-6',
    date: '2026-06-28',
    title: '追剧订阅与更新提醒功能',
    desc: '新增追剧订阅列表，关注喜欢的剧集后将在更新时收到提醒。支持按更新时间排序，不错过任何一集的精彩内容，追剧体验全面升级。',
    tag: '功能更新',
  },
  {
    id: 'update-7',
    date: '2026-06-20',
    title: '纪录片频道独立上线',
    desc: '将纪录片内容独立为专区频道，按自然、历史、科技、人文四大主题分类。新增BBC、国家地理等优质纪录片资源，为知识探索爱好者提供丰富选择。',
    tag: '内容更新',
  },
  {
    id: 'update-8',
    date: '2026-06-12',
    title: '全站性能优化 · 加载速度提升50%',
    desc: '对全站前端架构进行深度优化，页面加载速度提升约50%。优化了图片懒加载策略和资源预加载机制，即使用户在弱网环境下也能快速访问春夜影院。',
    tag: '性能优化',
  },
];

const commentItems = [
  {
    id: 'cmt-1',
    name: '电影爱好者小王',
    date: '2026-07-29',
    rating: 5,
    content: '春夜影院的蓝光画质真的太棒了！之前一直在找能流畅看高清电影的地方，试了好多网站都各种缓冲，春夜影院完全不卡，而且资源更新特别快，每周五都有新片上架，已经推荐给身边所有朋友了。',
  },
  {
    id: 'cmt-2',
    name: '追剧达人小李',
    date: '2026-07-27',
    rating: 5,
    content: '作为一个重度追剧人，春夜影院完美满足了我的需求。热播剧全集连播，更新速度跟电视台几乎同步，画质清晰不缓冲。最赞的是不用注册就能看，打开网页即看即走，太方便了。',
  },
  {
    id: 'cmt-3',
    name: '综艺迷小张',
    date: '2026-07-25',
    rating: 4,
    content: '综艺资源很全，国内外热门综艺基本都有。更新速度挺快的，播出后第二天就能看到。希望后续能增加更多海外综艺节目，比如一些冷门但质量很高的小众综艺。整体体验很不错。',
  },
  {
    id: 'cmt-4',
    name: '动漫爱好者小陈',
    date: '2026-07-22',
    rating: 5,
    content: '日漫国漫资源都很丰富，新番更新及时，经典老番也能找到。画质很好，看战斗场景特别爽。用手机版在地铁上看动漫已经成为我每天的固定节目了，流畅不卡顿真的很重要。',
  },
  {
    id: 'cmt-5',
    name: '纪录片迷老刘',
    date: '2026-07-20',
    rating: 5,
    content: '春夜影院的纪录片专区做得非常好，分类清晰内容扎实。BBC和国家地理的资源画质都很棒，晚上泡杯茶看一部纪录片已经成为习惯了。免费高清没有广告打扰，观影体验远超预期。',
  },
];

export default function SectionsD() {
  const handleClick = (href: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      {/* #updates - 8 timeline items */}
      <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-100 scroll-mt-16">
        <div className="max-w-[1440px] mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3 whitespace-nowrap">
              站点动态
            </span>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新动态
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              春夜影院最新的功能升级、内容更新与运营动态一览
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            {updateItems.map((item, idx) => (
              <div key={item.id} className="relative flex gap-4 md:gap-6 pb-8 md:pb-10 last:pb-0">
                {/* Timeline line */}
                {idx < updateItems.length - 1 && (
                  <div className="absolute left-[19px] md:left-[21px] top-12 bottom-0 w-px bg-background-300"></div>
                )}

                {/* Timeline dot */}
                <div className="relative z-10 w-10 h-10 md:w-11 md:h-11 rounded-full bg-primary-100 border-2 border-primary-200 flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-calendar-event-line text-primary-600 text-sm"></i>
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0 pt-1.5">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                    <span className={`text-[10px] px-2 py-0.5 rounded whitespace-nowrap ${
                      item.tag === '功能更新' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '技术升级' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '内容更新' ? 'bg-secondary-100 text-secondary-700' :
                      item.tag === '体验优化' ? 'bg-secondary-100 text-secondary-700' :
                      item.tag === '画质升级' ? 'bg-accent-100 text-accent-700' :
                      'bg-background-200 text-foreground-500'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #app - 1 app/mobile entry */}
      <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-50 scroll-mt-16">
        <div className="max-w-[1440px] mx-auto">
          <div className="max-w-4xl mx-auto">
            <div className="bg-background-900 rounded-2xl overflow-hidden">
              <div className="flex flex-col lg:flex-row items-center">
                {/* Text side */}
                <div className="w-full lg:w-[55%] p-6 md:p-10 lg:p-12 text-left">
                  <span className="inline-block px-3 py-1 rounded-full bg-primary-500/20 text-primary-300 text-xs font-medium mb-4 whitespace-nowrap">
                    随时随地
                  </span>
                  <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-white mb-3">
                    手机版 · 掌上春夜影院
                  </h2>
                  <p className="text-sm md:text-base text-white/65 leading-relaxed mb-6">
                    春夜影院手机版完美适配各类移动设备屏幕，无需下载安装任何APP。打开手机浏览器访问春夜影院最新地址，即可享受与电脑端一致的蓝光画质与流畅播放体验。地铁上、午休时、旅途中，随时随地畅享高清影视。
                  </p>
                  <div className="flex flex-wrap gap-3 mb-6">
                    <div className="flex items-center gap-2 text-white/70 text-xs">
                      <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
                      <span>无需下载安装</span>
                    </div>
                    <div className="flex items-center gap-2 text-white/70 text-xs">
                      <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
                      <span>自适应屏幕尺寸</span>
                    </div>
                    <div className="flex items-center gap-2 text-white/70 text-xs">
                      <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
                      <span>极速加载省流量</span>
                    </div>
                    <div className="flex items-center gap-2 text-white/70 text-xs">
                      <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
                      <span>夜间模式护眼</span>
                    </div>
                  </div>
                  <a
                    href="#hero"
                    onClick={handleClick('#hero')}
                    className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-smartphone-line text-base"></i>
                    立即体验手机版
                  </a>
                </div>

                {/* Visual side */}
                <div className="w-full lg:w-[45%] p-6 md:p-8 lg:p-0 lg:pr-8 flex items-center justify-center">
                  <div className="relative w-full max-w-[280px]">
                    <div className="aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-700 shadow-2xl">
                      <img
                        src="https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20elegant%20movie%20streaming%20interface%20with%20film%20posters%20on%20warm%20dark%20background%20cinematic%20app%20design%20with%20soft%20golden%20accents%20modern%20mobile%20UI%20aesthetic&width=600&height=1067&seq=app-mobile-2026-01&orientation=portrait"
                        alt="春夜影院手机版界面"
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* #about - 1 about section */}
      <section id="about" className="py-12 md:py-16 px-4 md:px-6 bg-background-100 scroll-mt-16">
        <div className="max-w-[1440px] mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3 whitespace-nowrap">
              关于我们
            </span>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2">
              关于春夜影院
            </h2>
            <p className="text-sm text-foreground-500 mb-8">
              免费高清影视在线观看平台
            </p>

            <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8 text-left">
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                春夜影院成立于2024年，是一个专业的免费高清影视在线观看平台。我们致力于为全球华语观众提供最新电影、热播电视剧、热门综艺、动漫番剧以及优质纪录片等多元化影视内容。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                平台以"蓝光画质、不缓冲、流畅播放"为核心优势，采用先进的视频编码与CDN加速技术，确保每一位用户都能获得极致的观影体验。无论是电脑端还是手机版，春夜影院均提供一致的高品质服务。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                我们坚持免费观影理念，所有内容均无需付费或订阅会员。通过广告合作与运营优化维持平台的可持续发展。每日更新海量资源，紧跟影视行业动态，努力成为您最值得信赖的免费在线观影平台。
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed">
                春夜影院官网入口与最新地址始终保持更新，请通过本站获取官方访问方式。如遇访问异常或有任何建议，欢迎通过「联系咨询」模块与我们取得联系，运营团队将在24小时内回复。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* #comments - 5 static reader comments */}
      <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-50 scroll-mt-16">
        <div className="max-w-[1440px] mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">
              用户口碑
            </span>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2">
              观众评论
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              来自真实观众的使用反馈与观影感受
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
            {commentItems.map((item) => (
              <div
                key={item.id}
                className="bg-background-100 rounded-xl border border-background-200/70 p-5 md:p-6"
              >
                {/* Stars */}
                <div className="flex items-center gap-0.5 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-xs ${i < item.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-300'}`}
                    ></i>
                  ))}
                </div>

                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-5">
                  {item.content}
                </p>

                <div className="flex items-center gap-3 pt-3 border-t border-background-200/50">
                  <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <span className="text-xs font-bold text-primary-600">
                      {item.name.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <div className="text-xs font-medium text-foreground-900 whitespace-nowrap">{item.name}</div>
                    <div className="text-[10px] text-foreground-400 whitespace-nowrap">{item.date}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}